import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import ClinicSetupPage from './pages/ClinicSetupPage';
import ProtectedRoute from './components/ProtectedRoute';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import ClinicAdminDashboard from './pages/ClinicAdminDashboard';
import AssistantDashboard from './pages/AssistantDashboard';
import DoctorDashboard from './pages/DoctorDashboard';
import PatientDashboard from './pages/PatientDashboard';
import GuestReschedule from './pages/GuestReschedule';
import PaymentPage from './pages/PaymentPage';

// Placeholder Dashboards (will be moved to separate files later)
const DashboardLayout = ({ title, role }) => (
  <div style={{ display: 'flex', height: '100vh', backgroundColor: 'var(--bg-color)' }}>
    <aside style={{ width: '250px', backgroundColor: 'white', borderRight: '1px solid var(--border-color)', padding: '1.5rem' }}>
      <h2 style={{ color: 'var(--primary-color)', marginTop: 0 }}>Medoro</h2>
      <nav style={{ marginTop: '2rem' }}>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li style={{ marginBottom: '0.75rem', fontWeight: 500 }}>Dashboard</li>
          <li style={{ marginBottom: '0.75rem', color: 'var(--text-secondary)' }}>Appointments</li>
          <li style={{ marginBottom: '0.75rem', color: 'var(--text-secondary)' }}>Settings</li>
        </ul>
      </nav>
    </aside>
    <main style={{ flex: 1, padding: '2rem' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem' }}>{title}</h1>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <span>{role}</span>
          <button className="btn btn-primary" onClick={() => { localStorage.removeItem('token'); window.location.href = '/login'; }}>Logout</button>
        </div>
      </header>
      <div className="card">
        <h3>Welcome back!</h3>
        <p>This is the {title}. You are logged in as a {role}.</p>
      </div>
    </main>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/clinic-setup/:token" element={<ClinicSetupPage />} />
          <Route path="/reschedule-guest/:token" element={<GuestReschedule />} />
          <Route path="/pay/:appointmentId" element={<PaymentPage />} />

          {/* Protected Routes */}
          <Route path="/super-admin" element={
            <ProtectedRoute roles={['SuperAdmin']}>
              <SuperAdminDashboard />
            </ProtectedRoute>
          } />

          <Route path="/clinic-admin" element={
            <ProtectedRoute allowedRoles={['ClinicAdmin']}>
              <ClinicAdminDashboard />
            </ProtectedRoute>
          } />

          <Route path="/assistant-dashboard" element={
            <ProtectedRoute allowedRoles={['Assistant']}>
              <AssistantDashboard />
            </ProtectedRoute>
          } />

          <Route path="/doctor-dashboard" element={
            <ProtectedRoute allowedRoles={['Doctor']}>
              <DoctorDashboard />
            </ProtectedRoute>
          } />

          <Route path="/patient-dashboard" element={
            <ProtectedRoute allowedRoles={['Patient']}>
              <PatientDashboard />
            </ProtectedRoute>
          } />

          <Route path="/unauthorized" element={<div style={{ padding: '2rem', textAlign: 'center' }}><h1>Unauthorized Access</h1></div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
